import { FieldJson } from 'edocatbase/Form';
import { last } from 'ramda';

const nullValueTemplates = [
  'asyncselect.ftl',
  'category.ftl',
  'selectone.ftl',
  'priority.ftl',
  'taskowner.ftl',
  'selectmany.ftl',
  'selectmany.ftl',
  'association.ftl',
  'packageitems.ftl',
  'date.ftl',
  'authority.ftl',
  'noderef.ftl',
];

const getFieldEmptyValue = (field: FieldJson) => {
  const template = last(field.control.template.split('/'));
  if (!template) return '';
  if (nullValueTemplates.includes(template)) return null;
  if (template === 'daterange.ftl') return { start: null, end: null };
  return '';
};

export default getFieldEmptyValue;
